import { getProjectSchema } from "./getProjectSchema";
import { getEquipmentSchema } from "./getEquipmentSchema";
import { getIssueSchema } from "./getIssueSchema";
import { getCommentSchema } from "./getCommentSchema";
import { getObservationSchema } from "./getObservationSchema";
import { getEditorTrackingFields } from "./getEditorTrackingFields";
import { getChecklistSchema } from "./getChecklistSchema";
import { getChecklistRowsSchema } from "./getChecklistRowsSchema";
import { getProjectChecklistSchema } from "./getProjectChecklistSchema";
import { getContactSchema } from "./getContactSchema";

export function getSchema(tablename) {
  // var schema = \\await getFeatures("schemas", "tableName", tablename);
  var schema =
    tablename === "projects"
      ? getProjectSchema().concat(getEditorTrackingFields())
      : tablename === "equipment"
      ? getEquipmentSchema().concat(getEditorTrackingFields())
      : tablename === "contact"
      ? getContactSchema().concat(getEditorTrackingFields())
      : tablename === "comment"
      ? getCommentSchema().concat(getEditorTrackingFields())
      : tablename === "checklist-rows"
      ? getChecklistRowsSchema()
      : tablename === "checklist"
      ? getChecklistSchema().concat(getEditorTrackingFields())
      : tablename === "project-checklist"
      ? getProjectChecklistSchema().concat(getEditorTrackingFields())
      : tablename === "issue"
      ? getIssueSchema().concat(getEditorTrackingFields())
      : tablename === "observation"
      ? getObservationSchema().concat(getEditorTrackingFields())
      : [];

  return schema;
}
